import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTextarea from '@src/mobile/phtvHostArea2025/layout/Component/FormTextarea';
import FormWaring from '@src/mobile/phtvHostArea2025/layout/Component/FormWaring';
import { area } from '@src/utils/area';
import UploadVideo from '@src/mobile/phtvHostArea2025/layout/Media/UploadVideo';

const Needlessly = ({ formData, setFormDataHandle, warningTextList, updateSuccess, languages }) => {
    const [isUnfold, setUnfold] = useState(true);

    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.needlessly}>
            <div className={styles.needlesslyHead}>
                <div className={styles.needlesslyTitle}>{area[languages].optionalInfo.title}</div>
                <div className={styles.needlesslyBref} dangerouslySetInnerHTML={{ __html: area[languages].optionalInfo.placeholder }} />
            </div>
            <div style={{ display: isUnfold ? 'block' : 'none' }} className={styles.formNeedlesslyList}>
                <div className={styles.formListBox}>
                    {/* 默认提示词 */}
                    <FormTextarea placeholder={area[languages].optional.placeholder} formData={formData} name="optional" changeInputHandle={changeInputHandle} updateSuccess={updateSuccess} />
                    <FormWaring warningText={warningTextList['optional']} />
                    {/* 视频作品 */}
                    <UploadVideo name="video2" formData={formData} changeInputHandle={changeInputHandle} languages={languages} />
                    <FormWaring warningText={warningTextList['video2']} />
                </div>
            </div>
        </div>
    );
};

Needlessly.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateSuccess: PropTypes.bool,
    languages: PropTypes.string,
};

export default errorBoundary(Needlessly);
